import React from 'react';

const CourseListPage = () => <h1>Lista de Cursos</h1>;

export default CourseListPage;
